<button
  mat-icon-button
  [matMenuTriggerFor]="menu">
  <mf-icon
    [icon]="icons.notifications"
    [numberBadge]="(notificationTray | async)?.unread?.length ?? 0"
    [rotate]="45"></mf-icon>
</button>

<mat-menu
  class="notification-menu"
  #menu="matMenu">
  <div
    class="mat-menu-content"
    (click)="$event.stopPropagation()">
    <div class="notification-title-container">
      <h2
        class="menu-title"
        (click)="openNotifications()">
        Notificaciones
      </h2>
      <button
        mat-button
        matTooltip="Marcar todas como leídas"
        (click)="setAllAsRead()"
        closeMenu>
        Marcar como leídas
      </button>
    </div>

    @if (notificationTray | async) { @if ( !(notificationTray | async)?.unread?.length) {
    <p>No hay nuevas notificaciones para mostrar</p>
    } } @for (notification of (notificationTray | async)?.unread; track notification.id) {
    <mf-notification-menu-item [notification]="notification"></mf-notification-menu-item>
    }
  </div>
</mat-menu>
